module.exports = __webpack_public_path__ + "static/media/pic8.69a9331a.jpg";